import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={46}
            height={47}
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect x={0.5} y={0.898438} width={45} height={45} rx={22.5} fill="#fff" />
        <rect
            x={0.5}
            y={0.898438}
            width={45}
            height={45}
            rx={22.5}
            stroke={theme["#0EA59D"]}
        />
        <path
            d="M24.041 23.884v1.65a1.042 1.042 0 01-2.083 0v-1.65c-.3-.183-.534-.45-.7-.767h-5.759a.836.836 0 00-.833.834v2.941a4.84 4.84 0 004.842 4.842h6.975a4.842 4.842 0 004.85-4.842v-2.941a.836.836 0 00-.834-.834h-5.758c-.167.317-.4.584-.7.767zM26.491 15.066h-6.983a4.84 4.84 0 00-4.842 4.842v1.125c0 .458.375.833.833.833h5.559a1.976 1.976 0 012.475-1.566 1.965 1.965 0 011.383 1.383c.017.058.017.125.025.183h5.558a.836.836 0 00.834-.833v-1.125a4.84 4.84 0 00-4.842-4.842z"
            fill={theme["#0D968F"]}
        />
        </svg>
    )
}
  
  export default SvgComponent